jQuery(document).ready(function($){
  if(jQuery('#countdownEliving').length > 0){
     var date = jQuery('#countdownEliving').attr('data-date').replace("-", "/");
     date = date.replace("-","/");
  	 if(date != '' && date != null && date != 'undefiend'){
        jQuery('#countdownEliving').countdowneliving({
            date: date+' 23:59:59', 
            offset: +11.01610, 
            hideOnComplete: true
          }, function (container) {
            //  jQuery('#covid-topbar').hide();
       });
 	 }
  } 

  if(jQuery('#countdownLifelySale').length > 0){
     var date = jQuery('#countdownLifelySale').attr('data-date').replace("-", "/");
     date = date.replace("-","/");
     if(date != '' && date != null && date != 'undefiend'){
        jQuery('#countdownLifelySale').countdowneliving({
            date: date+' 23:59:59', 
            offset: +11.01610, 
            hideOnComplete: true
          }, function (container) {
            //  jQuery('#covid-topbar').hide();
       });
     }
  } 
  
  if(jQuery('#countdownClearance_bar').length > 0){
     var date = jQuery('#countdownClearance_bar').attr('data-date').replace("-", "/");
     date = date.replace("-","/");
  	 if(date != '' && date != null && date != 'undefiend'){
        jQuery('#countdownClearance_bar').countdowneliving({
            date: date+' 23:59:59', 
            offset: +11.01610, 
            hideOnComplete: true
          }, function (container) {
            //  jQuery('#covid-topbar').hide();
       });
 	 }
  } 
  
  // if(jQuery('#countdownCart').length > 0){
  //    var date_p = jQuery('#countdownCart').attr('data-date').replace("-", "/");   
  //    date_p = date_p.replace("-","/");
  // 	 if(date_p != '' && date_p != null && date_p != 'undefiend'){
  //        date_p = (date_p+' 23:59:59');
  //      console.log('########')
  //      console.log(date_p);
  //      console.log('########')
  //       jQuery('#countdownCart').countdowneliving({
  //           date: date_p, 
  //           offset: +11.01610
  //           // hideOnComplete: true
  //         }, function (container) {
  //           //  jQuery('#covid-topbar').hide();
  //      });
 	//  }
  // }

  if(jQuery('#cartcountdownEliving').length > 0){
     var date_p = jQuery('#cartcountdownEliving').attr('data-date').replace("-", "/");   
     date_p = date_p.replace("-","/");
  	 if(date_p != '' && date_p != null && date_p != 'undefiend'){
         date_p = (date_p+' 23:59:59');
        jQuery('#cartcountdownEliving').countdowneliving({
            date: date_p, 
            offset: +11.01610, 
            hideOnComplete: true
          }, function (container) {
            //  jQuery('#covid-topbar').hide();
       });
 	 }
  }

  if(jQuery('#cartcountdownEliving2').length > 0){
     var date_p = jQuery('#cartcountdownEliving2').attr('data-date').replace("-", "/");   
     date_p = date_p.replace("-","/");
  	 if(date_p != '' && date_p != null && date_p != 'undefiend'){
         date_p = (date_p+' 23:59:59');
        jQuery('#cartcountdownEliving2').countdowneliving({
            date: date_p, 
            offset: +11.01610, 
            hideOnComplete: true
          }, function (container) {
            //  jQuery('#covid-topbar').hide();
       });
 	 }
  }


  if(jQuery('#countdownHomepage_bar').length > 0){
     var date = jQuery('#countdownHomepage_bar').attr('data-date').replace("-", "/");
     date = date.replace("-","/");
  	 if(date != '' && date != null && date != 'undefiend'){
        jQuery('#countdownHomepage_bar').countdowneliving({
            date: date+' 23:59:59', 
            offset: +11.01610, 
            hideOnComplete: true
          }, function (container) {
            //  jQuery('#covid-topbar').hide();
       });
 	 }
  } 

  
  
});